import { Controller } from "@hotwired/stimulus"

// Team page: "Team" | "Owner's Reps" (James / Phelipe 2026-10-20). The two
// panels sit outside the tab strip, found by data-team-tab-panel.
export default class extends Controller {
  static targets = ["teamBtn", "repsBtn"]

  showTeam() { this._show("team") }
  showReps() { this._show("reps") }

  _show(which) {
    document.querySelectorAll("[data-team-tab-panel]").forEach(el => {
      el.classList.toggle("hidden", el.dataset.teamTabPanel !== which)
    })
    this._paint(this.teamBtnTarget, which === "team")
    this._paint(this.repsBtnTarget, which === "reps")
  }

  _paint(btn, active) {
    btn.classList.toggle("text-brand", active)
    btn.classList.toggle("font-bold", active)
    btn.classList.toggle("text-text-muted", !active)
    btn.classList.toggle("font-medium", !active)
    btn.classList.toggle("hover:text-gray-700", !active)
  }
}
